export default "__VITE_ASSET__Clm_p43g__"